export const commaSeparatedString = (number: any) => {
    if (number === 0) {
      return '0';
    }
  
    const numberString = String(number);
    const decimalIndex = numberString.indexOf('.');
    let integerPart = numberString;
    let decimalPart = '';
  
    if (decimalIndex !== -1) {
      integerPart = numberString.slice(0, decimalIndex);
      decimalPart = numberString.slice(decimalIndex);
    }
  
    const thousandsRegExp = /\B(?=(\d{3})+(?!\d))/g;
    const formattedIntegerPart = integerPart.replace(thousandsRegExp, ',');
  
    return formattedIntegerPart + decimalPart;
  }

export const mapDsxLevel = (level: string) => {
  const dsxMapping:any = {
    "All-Star": "DSX1",
    "Analyst": "DSX2",
    "Sr Analyst": "DSX3",
    "Lead Analyst": "DSX4",
    "Manager": "DSX5",
    "Sr Manager": "DSX6",
    "Asso Dir": "DSX7",
    "Director": "DSX8",
    "Sr Director": "DSX9",
    "VP": "DSX10",
    "SVP": "DSX11",
    "Custom": ""
  }
  return dsxMapping[level]
}
